/** Parent org names that should not be shown as the agency label in the UI. */
const GENERIC_ORG_NAMES = /^unity$/i;

export function resolveOrganizationDisplayName(activeLocation, currentUser) {
  const candidates = [
    activeLocation?.organizationName,
    activeLocation?.companyName,
    currentUser?.company?.name,
    currentUser?.companyName,
  ];

  for (const name of candidates) {
    const trimmed = String(name || "").trim();
    if (trimmed && !GENERIC_ORG_NAMES.test(trimmed)) {
      return trimmed;
    }
  }

  return "";
}
